import moment from 'moment';
import {request} from '../helpers/request'
import {getSourceNameAndCc} from '../helpers/getSourceData'
import LoadingComponent from './common/LoadingComponent'
import React from 'react'
import _ from 'lodash'
import Immutable from 'immutable'
import PremiumUpdateComponent from './common/PremiumUpdateComponent'
import AssociatedApplicantComponent from './common/AssociatedApplicantComponent'
import AttachmentComponent from './common/AttachmentComponent'
import Document from './common/Document'
import HistoryComponent from './common/HistoryComponent'
import FieldComponent from './common/FieldComponent'
import ConfirmationEmailComponent from './common/ConfirmationEmailComponent'
import RenewalEmailComponent from './common/RenewalEmailComponent'
import ModalComponent from './common/ModalComponent'
import NoteComponent from './common/NoteComponent'
import ClaimComponent from './common/ClaimComponent'
import $ from 'jquery'
import {makeGrids, getFieldWidthClass} from '../helpers/makeGrids.js'
import {Panel, ListGroup, ListGroupItem, Button, ButtonGroup, ButtonToolbar} from 'react-bootstrap'
import {getObjectDifference} from '../helpers/getObjectDifference'
import CancelPolicyConfirmationComponent from './common/CancelPolicyConfirmationComponent'
import PremiumChangeSuccessComponent from './common/PremiumChangeSuccessComponent'
import Icon from 'react-fa'
import {t} from '../helpers/translate.js'
import {getStatusText} from '../helpers/getStatusText'
let config = require('config');
import accounting from 'accounting'

import * as access from '../helpers/access'

class Manage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      applicationLoaded: false,
      applicantLoaded: false,
      associatedApplicantLoaded: false,
      associatedApplicants: null,
      claimsLoaded: null,
      editMode: false,
      loading: true,
      loadingText: null,
      errors: Immutable.List(),
      showModal: false,
      showAlertModal: false,
      resetDataOnClose: true,
      showCancelPolicy: false,
      modalTitle: null,
      modalBody: null,
      onSubmitModal: null,
      onSubmitModalButtonName: null,
      data: Immutable.Map({}),
      backup: Immutable.Map({}),
      changeHistoryData: null,
      parsedForm: null,
      paymentHistoryData: null,
      paymentsToProcess: [],
      paymentSuccessful: null,
      savingChanges: false,
      sourceFullName: null,
      sourceCC: null,
      quoteRequestData: null,
      quoteResponseData: null,
      overridePremium: false,
      processingFailedPayments: false,
      updatingCard: false,
    }
  }

  getSource() {
    return this.props.params.source;
  }

  /**
   * Toggles the Void status to Cancelled and vice versa.
   */
  getNewStatus() {
    return this.isPolicyStatus('void') ? 'cancelled' : 'void';
  }

  componentWillMount() {
    getSourceNameAndCc(this.getSource(), this);
    this.loadData();
  }

  getPremiumDifference() {
    if (this.state.quoteResponseData) {
      return this.state.quoteResponseData.premium_difference
    }
    return null;
  }

  loadData() {
    const baseApi = config.default.api;
    const appId = this.getApplicationId();
    const method = 'GET';

    $.when(
      request(`${baseApi}/application/${this.getSource()}/${appId}`, method, null, this.loadApplicationData.bind(this)),
      request(`${baseApi}/applicant/${this.getSource()}/${appId}`, method, null, this.loadApplicantsData.bind(this)),
      request(`${baseApi}/associatedapplicant/${this.getSource()}/${appId}`, method, null, this.loadAssociatedApplicantsData.bind(this)),
      request(`${baseApi}/history/${this.getSource()}/${appId}`, method, null, this.loadHistoryData.bind(this)),
      request(`${baseApi}/payment/${this.getSource()}/${appId}`, method, null, this.loadPaymentData.bind(this)),
      access.canViewClaims() ? request(`${baseApi}/claims/${appId}`, method, null, this.loadClaimsData.bind(this)) : this.setState({claimsLoaded: []})
    )
    .done(this.parseForm.bind(this));
  }

  getFormConfig(){
    return config.default.clients[this.getSource()].configuration_form.expanded
  }

  parseForm() {
    this.setState({
      parsedForm:
        this.getFormConfig().reduce(
          (previousGroups, currentGroup) => {
            if (currentGroup.repeat) {
              for (let i = currentGroup.repeat.start; i < this.repeatCount(currentGroup); i++) {
                previousGroups.push(Manage.parseRepeatable(currentGroup, i));
              }
            } else {
              previousGroups.push(currentGroup);
            }

            return previousGroups;
          }, []
        ),
      loading: false
    });
  }

  static parseRepeatable(group, index) {
    return JSON.parse(
      JSON.stringify(group)
        .replace(/\*\+\+/g, String(index + 1))
        .replace(/\*/g, String(index))
    );
  }

  loadApplicationData(responseData, statusCode) {
    if (statusCode == 200) {
      let applicationData = Immutable.fromJS(responseData);
      this.state.overridePremium = responseData.override_premium ? true : false
      this.state.netRate = responseData.additional_data.net_rate ? true : false
      this.setState({
        applicationLoaded: true,
        data: this.state.data.set('application', applicationData),
        backup: this.state.backup.set('application', applicationData),
        policy_application_fee: responseData.policy_cancellation_fee
      })
    } else {
      this.showModal( t('Error'), t('Unable to get application data'));
    }
  }

  loadApplicantsData(responseData, statusCode) {
    if (statusCode == 200) {
      let applicantsData = Immutable.fromJS(responseData.applicants);
      this.setState({
        applicantLoaded: true,
        data: this.state.data.set('applicant', applicantsData),
        backup: this.state.backup.set('applicant', applicantsData)
      })
    } else {
      this.showModal( t('Error'), t('Unable to get applicant data'));
    }
  }

  loadAssociatedApplicantsData(responseData, statusCode) {
    if (statusCode == 200) {
      let associatedApplicantsData = Immutable.fromJS(responseData.applicants);
      this.setState({
        associatedApplicantLoaded: true,
        data: this.state.data.set('associatedapplicant', associatedApplicantsData),
        backup: this.state.backup.set('associatedapplicant', associatedApplicantsData),
        associatedApplicants: responseData.applicants
      })
    } else {
      this.showModal( t('Error'), t('Unable to get applicant data'));
    }
  }

  loadPaymentData(responseData, statusCode) {
    if (statusCode == 200) {
      this.setState({
        paymentHistoryData: responseData
      })
    } else {
      this.showModal( t('Error'), t('Unable to get payment data'));
    }
  }

  loadClaimsData(responseData, statusCode) {
    if (statusCode == 200) {
      this.setState({
        claimsLoaded: responseData
      })
    } else {
      this.showModal( t('Error'), t('Unable to get claims data'));
    }
  }

  loadHistoryData(responseData, statusCode) {
    if (statusCode == 200) {
      this.setState({
        changeHistoryData: responseData
      })
    } else {
      this.showModal( t('Error'), t('Unable to get change history'));
    }
  }

  isDataReady() {
    return this.state.applicationLoaded &&
      this.state.applicantLoaded &&
      this.state.associatedApplicantLoaded &&
      this.state.paymentHistoryData &&
      this.state.claimsLoaded &&
      this.state.changeHistoryData &&
      this.state.parsedForm;
  }

  handleDataChange(delta) {
    this.setState({
      data: this.state.data.setIn(delta.key_path, delta.value),
      quoteResponseData: null
    })
  }

  handleModalClose(resetDataOnClose = true) {
    this.setState({
        showModal: false
      },
      this.resetDataOnModalClose(resetDataOnClose)
    )
  }

  resetDataOnModalClose(resetData){
    if (resetData) {
      this.resetData()
    }
  }

  enableEditMode() {
    this.setState({
      editMode: true,
      updatingCard: false,
      processingFailedPayments: false,
      paymentsToProcess: []
    })
  }

  disableEditMode() {
    this.setState({editMode: false})
  }

  postChargeData(requestBody) {
    this.setState({paymentSuccessful: null});
    request(`${config.default.api}/${'premium/charge'}/${this.getSource()}/${this.state.quoteResponseData.id}`, 'POST', requestBody, (data, statusCode) => {
      if (statusCode === 200) {
        var quote = this.state.quoteResponseData;
        this.setState({paymentSuccessful: true});
        this.showModal( t('Success'),
          <PremiumChangeSuccessComponent
            quote={quote}
            isOverride={this.state.overridePremium}
            originalPremium={this.getOriginalPremium()}
          />
        );
      } else if (statusCode === 400) {
        this.showModal(t('Success'), <div>{data.messages.map((message) => <p>{message}</p>)}</div>)
        this.setState({paymentSuccessful: false});
      } else {
        this.showModal(t('Error'), t('Unable to apply the premium change to the server.'))
        this.setState({paymentSuccessful: false});
      }
    })
  }

  handleRefundSuccess() {
    var quote = this.state.quoteResponseData;
    this.showModal(t('Success'),
      <PremiumChangeSuccessComponent
        quote={quote}
        isOverride={this.state.overridePremium}
        originalPremium={this.getOriginalPremium()}
      />
    );
  }

  applicantsDiff() {
    return this.state.data.get('applicant').toArray().map(
      (object, index) => {
        return getObjectDifference(object.toJS(), this.state.backup.getIn(['applicant', index]).toJS());
      }
    );
  }

  makeQuoteRequestData() {
    let applicants = this.applicantsDiff();

    let application = this.state.data.get('application').toJS();

    if (this.hasBackdating && application.additional_data.bq == undefined) {
      application.additional_data.bq = { backdating: 1 };
    }

    if (this.hasPolicyModification && application.additional_data.pmq == undefined) {
      application.additional_data.pmq = { modifypolicy: 1 };
    }

    let backupData = this.state.backup.get('application').toJS();

    if ((application.effective_date != backupData.effective_date) || (application.expiry_date !== backupData.expiry_date)) {
      application.additional_data.coverage_length = `${Math.abs(moment(application.effective_date).diff(moment(application.expiry_date), 'days')) + 1} Days`;
    }

    application = getObjectDifference(application, this.state.backup.get('application').toJS());

    let differenceImmutable = Immutable.fromJS({
      application: application,
      applicant: applicants
    });

    let renderedFieldKeys = Object.keys(this.refs);
    let renderedFieldKeyPaths = renderedFieldKeys.map((key) => key.split(','));
    let resultImmutable = Immutable.Map({
      applicant: Immutable.List(
        this.state.data.get('applicant').toArray().map(
          (applicantImmutable, index) => Immutable.Map().set('id', applicantImmutable.get('id'))
        )
      )
    });
    for (let keyPath of renderedFieldKeyPaths) {
      let value = differenceImmutable.getIn(keyPath);
      if (value !== undefined) {
        resultImmutable = resultImmutable.setIn(keyPath, value)
      }
    }
    resultImmutable = resultImmutable.set('applicants', resultImmutable.get('applicant')).delete('applicant')
    let result = resultImmutable.toJS();
    if (_.isEmpty(result.application)) delete result.application;
    if (_.isEmpty(result.applicants)) delete result.applicants;
    return result;
  }

  scrollToTheTop() {
    $('html, body').animate({scrollTop: 0}, 'fast');
  }

  postQuoteRequestData(onSuccess) {
    this.cleanErrors();
    let quoteRequestData = this.makeQuoteRequestData();
    this.setState({quoteRequestData: quoteRequestData, gettingQuote: true},
      () => {
        request(`${config.default.api}/${'premium/quote'}/${this.getSource()}/${this.getApplicationId()}`, 'POST', quoteRequestData, (data, statusCode) => {
          if (statusCode == 200) {
            this.setState({
                quoteResponseData: data
              }, () => {
                onSuccess(data)
              }
            );
          } else if (statusCode == 400) {
            this.scrollToTheTop();
            this.setState({
                errors: this.state.errors.concat(data.messages.map((m) =>
                  (() => {
                    return {
                      key: m.key,
                      message: m.message
                    }
                  })()
                ))
              }
            );
          } else {
            this.showModal(t('Error'), t(`Unable to get quote (Code ${statusCode}).`))
          }
          this.setState({
            savingChanges: false,
            loading: false,
          })
        })
      }
    );
  }

  resetData(action) {
    this.setState({
        quoteResponseData: null,
        showAlertModal: false,
        loading: true
      }, function() {
        this.disableEditMode();
        this.cleanErrors();
        action != 'cancel' && this.loadData();
      }
    );
  }

  cleanErrors() {
    this.setState({
      errors: Immutable.List(),
      paymentSuccessful: null
      }
    )
  }

  getApplicationId() {
    return this.props.location.state.applicationId;
  }

  getOriginalPremium() {
    return this.state.data.getIn(['application', 'premium'])
  }

  getDefaultEmail(context) {
    return context.state.data.getIn(['applicant', '0', 'email']);
  }

  getSetCancellationFee() {
    let additionaData = this.state.data.getIn(['application', 'additional_data']);
    return additionaData.toJS().set_cancellation_fee;
  }

  repeatCount(group) {
    return this.state.data.getIn(group.repeat.key_path).count();
  }

  getClaims() {
    return this.state.data.getIn(['application', 'claims']).toJS();
  }

  getNotes() {
    return this.state.data.getIn(['application', 'notes']).toJS();
  }

  getAttachments() {
    return this.state.data.getIn(['application', 'attachments']).toJS();
  }

  handleCancelPolicy() {
    this.setState({
      showCancelPolicy: true
    })
  }

  handleRefundAndCancelPolicyClose(action = null) {
    this.setState({
      showCancelPolicy: false,
    }, this.resetData(action))
  }

  isPolicyCancellable() {
    return this.state.data.getIn(['application', 'active']);
  }

  showModal(title, body, resetDataOnClose = true) {
    this.setState({
        showModal: true,
        modalBody: t(body),
        modalTitle: t(title),
        resetDataOnClose: resetDataOnClose,
        loading: false
      })
    this.hideLoading();
  }

  showAlertModal(title, body, button, buttonAction) {
    this.setState({
      showAlertModal: true,
      alertModalBody: body,
      alertModalTitle: title,
      modalOptionalButton: t(button),
      modalAction: buttonAction
    })
  }

  showLoading(text = null) {
    this.setState({
        loading: true,
        loadingText: text
      }
    )
  }

  hideLoading() {
    this.setState({
        loading: false,
        loadingText: null
      }
    )
  }

  renderReloadButton(){
    return <Button onClick={this.loadData.bind(this)}><Icon name="refresh"/> {t('Reload')}</Button>
  }

  renderModifyButton() {
    return (
      (
        !this.isPolicyStatus('expired') && !this.isPolicyStatus('incomplete application')) 
        || access.isMshAdmin() 
        || (access.isAdmin() && !access.checkOrg('msg'))
      )
      && <Button onClick={this.enableEditMode.bind(this)}><Icon name="edit" /> {t('Modify Policy')}</Button>
  }

  renderCancelButton() {
    return (
      access.isMshAdmin()
      || ((access.isAdmin() && !access.checkOrg('msg')) && !this.isPolicyStatus('expired'))
      || (access.isSuperAdmin('ingle') && this.isPolicyStatus('expired'))
      || (this.isPolicyStatus('sold') && !(access.isGroupAdmin() || access.isReadonly() || access.userPermissions('agent', ['rimi', 'visitcanada', 'insurecanada'])))
    )
      && <Button onClick={this.handleCancelPolicy.bind(this)}><Icon name="ban" /> {t('Cancel Policy')}</Button>
  }

  renderRefundCancelledPoliciesButton(){
    return <ButtonGroup className="pull-right">
        <Button onClick={this.handleCancelPolicy.bind(this)}>
          <Icon name="ban"/> {t('Refund Premium')}
        </Button>
      </ButtonGroup>
  }

  renderVoidCheckbox(){
    return !config.default.clients[this.getSource()].restrictVoid &&
      <ButtonGroup className="pull-right">
        {t('Void Policy')}
        <input type="checkbox" name="void" id="voidCheckbox" checked={this.isPolicyStatus('void')} onClick={this.voidPolicy.bind(this)} />
      </ButtonGroup>
  }

  voidPolicy(){
    request(`${config.default.api}/policyVoid/${this.getApplicationId()}/${this.getNewStatus()}`,
      'POST',
      {'application_id': this.state.data.application_id},
      this.handlePolicyVoidResponse.bind(this),
      {
        'Content-Type': 'application/json'
      },
    );
  }

  handlePolicyVoidResponse(responseData, statusCode) {
    if (200 === statusCode) {
      this.loadApplicationData(responseData, statusCode);
    } else {
      this.showModal(t('Error'), t('Unable to void or cancel the policy'));
    }
  }

  renderReinstatePolicyButton(){
    return <ButtonGroup className="pull-right">
        <Button onClick={this.reinstatePolicy.bind(this)}>
          <Icon name="plane"/> {t('Reinstate Policy')}
        </Button>
      </ButtonGroup>
  }

  reinstatePolicy(){
    this.showLoading('Processing Request');
    request(`${config.default.api}/reinstatePolicy/${this.getApplicationId()}`,
      'POST',
      {'application_id': this.state.data.application_id},
      this.handleReinstatePolicyResponse.bind(this),
      {
        'Content-Type': 'application/json'
      },
    );
  }

  handleReinstatePolicyResponse(responseData, statusCode) {
    if (200 === statusCode) {
      this.loadData();
      this.showModal(t('Success'), t('Policy has been reinstated. Magenta status must be updated manually prior to processing premium payment.'));
    } else {
      this.showModal(t('Error'), t('Unable to reinstate the policy'));
    }
  }

  isPolicyStatus(status) {
    const args = {
      key_paths: {
        is_active: ['application', 'active'],
        effective_date: ['application', 'effective_date'],
        expiry_date: ['application', 'expiry_date'],
        status: ['application', 'status']
      }
    };

    const data = {data: this.state.data, args: args};

    return getStatusText(data).toLowerCase() === t(this.capitalizeFirstLetter(status)).toLowerCase();
  }

  capitalizeFirstLetter(string) {
    if (string.length > 1) {
      return string[0].toUpperCase() + string.substring(1);
    }
    return string;
  }

  getButtons() {
    return <ButtonToolbar>
      <button className="btn button-secondary" onClick={() => {window.history.back()}}>
        <Icon name="chevron-left"/> {t('Return to Search Results')}
      </button>
      { (this.isPolicyStatus('void') || this.isPolicyStatus('cancelled')) ?
        [
          access.isAdmin('ingle') && this.renderVoidCheckbox(),
          access.isMshAdmin() && this.renderRefundCancelledPoliciesButton(),
          access.isMshAdmin() && this.renderReinstatePolicyButton(),
        ]
        :
        (
          !(access.isReadonly() || access.isViewonly()) 
          && 
          (
            this.isPolicyStatus('sold') 
            || this.isPolicyStatus('active') 
            || this.isPolicyStatus('expired')
            || this.isPolicyStatus('incomplete application')
          )
        ) ?
          [<ButtonGroup className="pull-right">
            {this.state.editMode ?
              [<Button
                disabled={(this.state.quoteResponseData && this.getPremiumDifference() !== 0) || this.state.savingChanges}
                onClick={this.alertModal.bind(this)}>
                {this.state.savingChanges ? <Icon spin name="spinner" /> : <Icon name="save" />}
                {t('Save Changes')}
              </Button>,
              <Button onClick={this.resetData.bind(this)}>
                <Icon name="trash" /> {t('Discard Changes')}
              </Button>
              ]
              :
              [
                this.renderReloadButton(),
                this.renderModifyButton(),
                this.renderCancelButton()
              ]
            }
          </ButtonGroup>
          ]
          :
          <ButtonGroup className="pull-right">{this.renderReloadButton()}</ButtonGroup>
      }
      <div className='clearfix'></div>
    </ButtonToolbar>
  }
  oldMQ(){
    return  moment(this.state.data.getIn(['application', 'created_at'])).isBefore(moment('2023-09-19'));
  }
  checkCondition(condition){
    if (condition.values) {
      return condition.values.includes(this.state.data.getIn(condition.key_path));
    }

    if(!condition.function){
      return this.state.data.getIn(condition.key_path) === condition.value
    }

    if(condition.function == 'age'){
      return this.applicantNeedsMQ(this.state.data.getIn(condition.key_path), this.state.data.getIn(condition.original_age))
    }

    if (condition.function === 'backdate') {
      this.hasBackdating = !access.isAgent() && moment(this.state.data.getIn(['application', 'effective_date'])).isBefore(moment(this.state.data.getIn(['application', 'sale_date'])));
      return this.hasBackdating;
    }

    if (condition.function === 'modifypolicy') {
      const effectiveDateChanged = (this.state.data.getIn(['application', 'effective_date']) != this.state.backup.getIn(['application', 'effective_date']));
      const expiryDateChanged = (this.state.data.getIn(['application', 'expiry_date']) != this.state.backup.getIn(['application', 'expiry_date']));
      const countryChanged = (this.state.data.getIn(['application', 'additional_data', 'country_of_origin']) != this.state.backup.getIn(['application', 'additional_data', 'country_of_origin']));
      const otherPlanChanged = (this.state.data.getIn(['application', 'additional_data', 'other_plan']) != this.state.backup.getIn(['application', 'additional_data', 'other_plan']));
      const isActive = !moment(this.state.data.getIn(['application', 'effective_date'])).isAfter(moment());
      this.hasPolicyModification = this.state.data.getIn(['application', 'additional_data', 'pmq']) || isActive && access.isSchoolSuperAdmin() && (effectiveDateChanged || expiryDateChanged || countryChanged || otherPlanChanged);
      return this.hasPolicyModification;
    }

    if (condition.function === 'newmq') {
      return !this.oldMQ();
    }

    if (condition.function === 'oldmq') {
      return this.oldMQ();
    }
  }

  applicantNeedsMQ(value, originalAge){
    const age = this.getAge(value);
    const ageLimit = originalAge != undefined ? 75 : 70;
    return age >= ageLimit && age < 85;
  }

  getAge(value){
    const effMoment = moment(this.state.data.getIn(['application', 'effective_date']));
    return effMoment.diff(moment(value), 'years')
  }

  isStatic(field) {
    if (field.is_static_by_default)
      return true;

    if (this.state.editMode) {
      if (this.isPolicyStatus('incomplete application') && !access.isMshAdmin())
        return true;

      if (field.is_static_if) 
        return true;

      if (field.restricted_field_edit_to) {
        const restrictedEditTo = field.restricted_field_edit_to.map(([org, user, status]) => (access.getOrg() === org && access.getAccessLevel() === user && this.isPolicyStatus(status)));
        return restrictedEditTo.some(val => val === true);
      }
    }

    if (field.admin_edit_only) {
      return !(this.state.editMode && access.isMshAdmin());
    }

    if (field.admin_and_superadmin_edit_only) {
      const hasAdminPrivileges = access.isSchoolAdmin() || access.isAdmin();
      return !(this.state.editMode && hasAdminPrivileges);
    }

    return !(this.state.editMode && (this.state.overridePremium || (field.editable_if_override == null)));
  }

  hideIfSomeIsTrue(item){
    if (item.only_msh_admin && !(access.isMshAdmin() || access.isAdmin('ingle') || access.isReadonly('ingle'))) return true;
    return (item.do_not_show_if && item.do_not_show_if.some(this.checkCondition.bind(this)))
  }

  showIfEveryIsTrue(item){
    return (!item.show_if || item.show_if.every(this.checkCondition.bind(this)))
  }

  freezeField(affectsPremium, field) {
    return (affectsPremium || field.affects_premium) && !this.canModifyCoverage(field);
  }

  canModifyCoverage(field) {
    if (this.isPolicyStatus('sold')) return true;

    if (this.isPolicyStatus('active') && (access.isAdmin() || access.isSchoolSuperAdmin())) return true;

    if (access.isMshAdmin()
      || (access.isAdmin('ingle') && !(access.checkAccessLevel('admin')))
      || (access.userPermissions('admin', ['rimi', 'visitcanada', 'insurecanada']) && !this.isExpiryDate(field) && !this.state.data.getIn(['application', 'additional_data', 'date_cancelled_due_to_failed_payments']))
    ) return true;

    return false;
  }

  isExpiryDate(field) {
    return field.key_path.includes('expiry_date');
  }

  showSPModal(position) {
    const policyNumber = this.state.data.get('applicant').toJS()[position]['policy_number'];

    this.setState({
        showModal: true,
        modalBody: this.getSplitPolicyModalBody(policyNumber),
        modalTitle: 'Split Policy',
        resetDataOnClose: false,
        loading: false,
        onSubmitModalButtonName: 'Process Split',
        onSubmitModal: this.submitSplitPolicy.bind(this, policyNumber)
      }
    )
  }

  submitSplitPolicy(policyNumber) {
    this.showLoading('Processing Request');
    request(`${config.default.api}/splitPolicy/${this.getApplicationId()}`,
      'POST',
      {'policy_number': policyNumber},
      this.handlesplitPolicyResponse.bind(this),
      {
        'Content-Type': 'application/json'
      },
    );
  }

  handlesplitPolicyResponse(responseData, statusCode) {
    this.state.onSubmitModalButtonName = null;
    this.resetData()
    this.enableEditMode()

    if (200 === statusCode) {
      this.showModal(t('Success'), t('Policy has been split successfully'), false);
    } else {
      this.showModal(t('Error'), t('Unable to split the policy: ' + responseData.messages[0]));
    }
  }

  getSplitPolicyModalBody(policyNumber){
    return <div className="div-center">
      <br />
      <Icon name="warning" size="5x"/>
      <h3>{`${t('Are you sure you want to split policy number')} ${policyNumber}?`}</h3>
      <h4 className="message-alert">{t('This action is irreversible')}</h4>
    </div>
  }

  fill(fields, itemsPerRow, affectsPremium) {
    let elems = fields.map((field, index) => {
        if (this.hideIfSomeIsTrue(field)) {}
        else if (this.showIfEveryIsTrue(field)) {
          return <div key={index} className={getFieldWidthClass(field, itemsPerRow)}>
            <label className='text-uppercase'>{t(field.as)}</label>
            <div className='word-break'>
              <FieldComponent
                ref={field.key_path}
                onDataChanged={this.handleDataChange.bind(this)}
                type={field.type}
                format={field.format}
                keyPath={field.key_path}
                keyPathAliases={field.key_path_aliases}
                options={field.options}
                isStatic={this.isStatic(field) || this.freezeField(affectsPremium, field)}
                args={field.args}
                data={this.state.data}
                backup={this.state.backup}
                errors={this.state.errors}
                source={this.getSource()}
                buttonAction={this.showSPModal.bind(this)}
                editMode={this.state.editMode}                
              />
            </div>
          </div>
        }
      }
    );
    return makeGrids(itemsPerRow, elems.filter((elem) => elem), true);
  }

  updateCreditCard(paymentMethod) {
    this.showLoading('Updating Credit Card');
    request(`${config.default.api}/application/updatePaymentMethod/${this.getApplicationId()}`,
      'POST',
      {   'paymentMethod_id'       : paymentMethod.id,
          'paymentMethod_exp_month': paymentMethod.card.exp_month,
          'paymentMethod_exp_year' : paymentMethod.card.exp_year,
          'paymentMethod_last4'    : paymentMethod.card.last4,
          'paymentMethod_brand'    : paymentMethod.card.brand,
          'paymentMethod_name'     : paymentMethod.billing_details.name,
          'payment_provider'       : 'stripe',
      },
      this.handleUpdateCreditCardResponse.bind(this),
      {
        'Content-Type': 'application/json'
      }
    );
  }

  handleUpdateCreditCardResponse(response, statusCode) {
    this.toggleUpdatingCard();

    if (200 === statusCode) {
      this.showModal('Success', t('Your Credit Card was updated'));
    } else {
      this.showModal('Error', `${t('Your Credit Card was not updated')}: ${t(response.messages[0])}`);
    }
  }

  processFailedPayments(paymentMethod) {
    this.showLoading('Processing Payment');
    request(`${config.default.api}/processFailedPayments/${this.getApplicationId()}`,
      'POST',
      {   'payments_to_process'    : this.state.paymentsToProcess,
          'payment_method'         : paymentMethod.id,
          'paymentMethod_exp_month': paymentMethod.card.exp_month,
          'paymentMethod_exp_year' : paymentMethod.card.exp_year,
          'paymentMethod_last4'    : paymentMethod.card.last4,
          'paymentMethod_brand'    : paymentMethod.card.brand,
          'paymentMethod_name'     : paymentMethod.billing_details.name,
          'payment_provider'       : 'stripe',
      },
      this.handlePaymentProcessResponse.bind(this),
      {
        'Content-Type': 'application/json'
      }
    );
  }

  handlePaymentProcessResponse(response, statusCode) {
    this.hideLoading();
    this.toggleProcessingFailedPayments();
    if (200 === statusCode) {
      this.state.paymentsToProcess = [];
      this.showModal('Success', t('Your payment was processed'));
    } else {
      this.cleanUpPaymentsToProcess();
      this.showModal('Error', `${t('Your payment was not processed')}: ${t(response.messages[0])}`);
    }
  }

  isPolicyIssue(paymentID) {
    const matchingPayments = this.state.paymentHistoryData.payments.filter(payment => {
      return ((payment.id == paymentID) && (payment.additional_data.payment_type === "Policy Issue Fee"))
    })
    return matchingPayments.length > 0;
  }

  cleanUpPaymentsToProcess() {
    this.state.paymentsToProcess = this.state.paymentsToProcess.filter((payment) => {
      return !this.isPolicyIssue(payment)
    });
  }

  submitPremiumCharge(paymentMethod) {
    let data = {
      payment_provider: 'stripe',
      additional_data: {
        payment_method           : paymentMethod.id,
        payment_method_exp_month : paymentMethod.card.exp_month,
        payment_method_exp_year  : paymentMethod.card.exp_year,
        payment_method_last4     : paymentMethod.card.last4,
        payment_method_brand     : paymentMethod.card.brand,
        payment_method_name      : paymentMethod.billing_details.name,
        stripe                   : []
      }
    };

    this.showLoading('Processing Payment');

    request(`${config.default.api}/premium/charge/${this.getSource()}/${this.state.quoteResponseData.id}`, 'POST', data, (response, statusCode) => {
      this.hideLoading();
      if (statusCode === 200) {
        this.handleRefundSuccess();
      } else {
        this.showModal('Error', response.messages[0], false);
      }
    });
  }

  toggleUpdatingCard() {
    this.setState({
      updatingCard: !this.state.updatingCard
    })
  }

  toggleProcessingFailedPayments() {
    this.setState({
      processingFailedPayments: !this.state.processingFailedPayments
    })
  }

  addPaymentToBeProcessed(event) {
    let paymentsToProcess = this.state.paymentsToProcess;

    if(event.target.checked) {
      paymentsToProcess.push(event.target.value)
    }
    else{
      const index = paymentsToProcess.indexOf(event.target.value);
      paymentsToProcess.splice(index,1);
    }

    this.setPaymentsToBeProcessed(paymentsToProcess);
  }

  setPaymentsToBeProcessed(payments) {
    this.setState({paymentsToProcess: payments});
  }

  showConirmationModal(responseData, statusCode){
    if(statusCode == 200) {
      this.showModal('Success', 'Policy Issue Fee has been refunded');
    } else {
      this.showModal('Error', 'Policy Issue Fee could not be refunded');
    }
  }

  showCancellationConfirmationModal(responseData, statusCode){
    if(statusCode == 200) {
      this.showModal('Success', 'Cancellation Fee has been refunded');
    } else {
      this.showModal('Error', 'Cancellation Fee could not be refunded');
    }
  }

  showTransactionConfirmationModal(responseData, statusCode){
    if(statusCode == 200) {
      this.showModal('Success', 'Transaction Fee has been refunded');
    } else {
      this.showModal('Error', 'Transaction Fee could not be refunded');
    }
  }

  refundPolicyIssueFee(paymentId) {
    this.showLoading('Processing Refund');
    request(`${config.default.api}/refundpolicyfee/${this.getSource()}/${this.getApplicationId()}/${paymentId}`, 'GET', null, this.showConirmationModal.bind(this));
  }

  refundCancellationFee(paymentId) {
    this.showLoading('Processing Refund');
    request(`${config.default.api}/refundcancellationfee/${this.getSource()}/${this.getApplicationId()}/${paymentId}`, 'GET', null, this.showCancellationConfirmationModal.bind(this));
  }

  refundTransactionFee(paymentId) {
    this.showLoading('Processing Refund');
    request(`${config.default.api}/refundtransactionfee/${this.getSource()}/${this.getApplicationId()}/${paymentId}`, 'GET', null, this.showTransactionConfirmationModal.bind(this));
  }

  showModal(title, body, resetDataOnClose = true) {
    this.setState({
        showModal: true,
        modalBody: t(body),
        modalTitle: t(title),
        resetDataOnClose: resetDataOnClose
      }
    )
    this.hideLoading();
  }

  showAddon(group) {
    switch (group.addon.name) {
      case 'associated':
        return <AssociatedApplicantComponent
          applicants={this.state.data.associatedapplicant}
          originalPremium={this.getOriginalPremium()}
          onPaymentSuccess={this.postChargeData.bind(this)}
          onRefundSuccess={this.handleRefundSuccess.bind(this)}
          onCancel={this.cancelSavingChanges.bind(this)}
          source={this.getSource()}
          defaultProvider={config.default.payment_provider}
          {...this.state}
        />;
      case 'payment':
        return <PremiumUpdateComponent
          originalPremium={this.getOriginalPremium()}
          onPaymentSuccess={this.postChargeData.bind(this)}
          onRefundSuccess={this.handleRefundSuccess.bind(this)}
          onCancel={this.cancelSavingChanges.bind(this)}
          source={this.getSource()}
          applicationId={this.getApplicationId()}
          applicationData={this.state.data.toJS().application}
          defaultProvider={config.default.payment_provider}
          updatingCard={this.state.updatingCard}
          toggleUpdatingCard={this.toggleUpdatingCard.bind(this)}
          updateCreditCard={this.updateCreditCard.bind(this)}
          processingFailedPayments={this.state.processingFailedPayments}
          toggleProcessingFailedPayments={this.toggleProcessingFailedPayments.bind(this)}
          processFailedPayments={this.processFailedPayments.bind(this)}
          loadData={this.loadData.bind(this)}
          setPaymentsToBeProcessed={this.setPaymentsToBeProcessed.bind(this)}
          paymentsToProcess={this.state.paymentsToProcess}
          submitPremiumCharge={this.submitPremiumCharge.bind(this)}
          setCancellationFee={this.getSetCancellationFee()}
          showConfirmationModal={this.showModal.bind(this)}
          hideModal={this.handleModalClose.bind(this)}
          refundPolicyIssueFee={this.refundPolicyIssueFee.bind(this)}
          refundCancellationFee={this.refundCancellationFee.bind(this)}
          refundTransactionFee={this.refundTransactionFee.bind(this)}
          addPaymentToBeProcessed={this.addPaymentToBeProcessed.bind(this)}
          saveChanges={this.saveChanges.bind(this)}
          {...this.state}
        />;
      case 'email':
        return <ConfirmationEmailComponent
          source={this.getSource()}
          applicationId={this.getApplicationId()}
          defaultEmail={this.state.data.getIn(['applicant', '0', 'email'])}
          ccEmail={this.state.data.get('applicant').toJS()[0].additional_data.cc_email}
          agentEmail={this.state.data.getIn(['application', 'additional_data', 'agent_email'])}
          locale={this.state.data.get('application').toJS().locale}
          defaultCC={this.state.sourceCC}
          hasAgentCC={group.has_agent_cc}
          hideAutomaticCC={group.hide_automatic_cc}
          showLoading={this.showLoading.bind(this)}
          hideLoading={this.hideLoading.bind(this)}
        />;
      case 'renewal':
        const paymentProvider = this.state.paymentHistoryData.payments.length < 1 ? '' : this.state.paymentHistoryData.payments[0].payment_provider;
        return <RenewalEmailComponent
          source={this.getSource()}
          applicationId={this.getApplicationId()}
          defaultEmail={this.getDefaultEmail}
          context={this}
          ccEmail={this.state.data.get('applicant').toJS()[0].additional_data.cc_email}
          agentEmail={this.state.data.getIn(['application', 'additional_data', 'agent_email'])}
          locale={this.state.data.get('application').toJS().locale}
          defaultCC={this.state.sourceCC}
          showLoading={this.showLoading.bind(this)}
          hideLoading={this.hideLoading.bind(this)}
          paymentProvider={paymentProvider}
          trackingCode={this.state.data.getIn(['application', 'additional_data', 'tracking_code'])}
        />;
      case 'history':
        return <HistoryComponent
          groups={this.state.parsedForm}
          history={this.state.changeHistoryData}
          showCancelPolicy={this.state.showCancelPolicy}
        />;
      case 'note':
        return <NoteComponent
          source={this.getSource()}
          applicationId={this.getApplicationId()}
          notes={this.getNotes()}
          loadData={this.loadData.bind(this)}
          showModal={this.showModal.bind(this)}
        />;
      case 'attachment':
        return <AttachmentComponent
          source={this.getSource()}
          applicationId={this.getApplicationId()}
          attachments={this.getAttachments()}
          canUserAddAttachment={!access.isAgent('ingle')}
          showLoading={this.showLoading.bind(this)}
          hideLoading={this.hideLoading.bind(this)}
          loadData={this.loadData.bind(this)}
          showModal={this.showModal.bind(this)}
        />;
      case 'document':
        return <Document
          attachments={this.getAttachments()}
        />;
      case 'claim':
        return <ClaimComponent
          claims={this.state.claimsLoaded}
        />;
    }
  }

  saveChanges(options = {}) {
    const { pendPayment } = options
    this.cleanErrors();
    this.setState({
      loading: true,
      loadingText: t('Saving'),
      savingChanges: true,
      showAlertModal: false
    }, () => {
      this.postQuoteRequestData((data) => {
        if (data.premium_difference === 0 || pendPayment) {
          this.postChargeData(options);
        } else {
          const currency_format = config.default.currency_format;
          currency_format.symbol = this.state.quoteResponseData.currency;
          const difference = accounting.formatMoney(data.premium_difference, currency_format)
          const paymentType = data.premium_difference < 0 ? 'Refund' : 'Additional payment';

          this.showModal(t('Alert'), `${paymentType} required of ${difference}`, false);
        }
      })
    })
  }

  alertMessage(fields) {
    return (
      <p>{t('Changes to the following field(s) will not be reflected in True North:')}
        <ul>
          {fields.map((field, index) => (
            <li key={index}>{t(field)}</li>
          ))}
        </ul>
      </p>
    )
  }

  alertModal() {
    const fieldLabels = config.default.validate_truenorth_fields;
    const application = this.state.data.get('application').toJS();
    const isTrueNorth = this.getSource() === 'lloydscomprehensiveplus' && application.additional_data.affiliate_code === 'truenorth';
    let changes = [];

    const addChange = (key) => {
      if (!changes.includes(key)) {
        changes.push(key);
      }
    };

    const checkAdditionalFields = (dataObject) => {
      if (!dataObject) return;
  
      Object.keys(dataObject).forEach(key => {
        if (fieldLabels[key]) {
          addChange(key);
        }
      });
    };

    this.applicantsDiff().forEach(applicant => {
      Object.keys(applicant).forEach(key => {
        if (key === 'additional_data') {
          checkAdditionalFields(applicant[key]);
        } else if (fieldLabels[key]) {
          addChange(key);
          key === 'dob' && addChange('age');
        }
      });
    });

    const appDiff = getObjectDifference(application, this.state.backup.get('application').toJS());
    checkAdditionalFields(appDiff.additional_data);

    const fieldsChanged = changes.map(key => fieldLabels[key]).filter(label => label);

    if (isTrueNorth && fieldsChanged.length) {
      this.showAlertModal(t('Note:'), this.alertMessage(fieldsChanged), t('Save Changes'), this.saveChanges.bind(this));
    } else {
      this.saveChanges();
    }
  }

  cancelSavingChanges() {
    this.setState({
      savingChanges: false,
      quoteResponseData: null
    });
  }

  showPremiumOverrideMessage() {
    return this.state.overridePremium ? <div className='premium-override'>{t('This policy has a custom premium. Any changes to the premium must be calculated manually.')}</div> : null
  }

  showNetRateMessage() {
    return this.state.netRate ? <div className='premium-override'>{t('This policy was sold with preferred pricing. Confirmation emails must be sent to the agent who sold the policy. Do not send confirmation emails directly to the insured person.')}</div> : null
  }

  isGroupHidden (group) {
    return (group.restricted_access && group.restricted_access.includes(access.getAccessLevel())) || group.hidden;
  }

  getPageTitle(){
    return this.state.editMode ? t('Modify Policy') : t('View Policy')
  }

  render() {
    return this.isDataReady() ?
        <div className='container'>
          <div className="text-center page-title">
            <h1>{this.state.sourceFullName}</h1>
            <h2>{this.getPageTitle()}</h2>
          </div>
          {this.showNetRateMessage()}
          {this.showPremiumOverrideMessage()}
          <Panel header={this.getButtons()}>
            <ListGroup fill>
              {
                this.state.editMode && this.state.errors.count() > 0 ?
                  <ListGroupItem bsStyle="danger">
                    <ul>{
                      this.state.errors.toArray().map(
                        (error, index) => <li key={index}>
                          {error.message}
                        </li>)}</ul>
                  </ListGroupItem>
                  : null
              }
              {
                this.state.parsedForm.map(
                  (group, i) => {
                    let groupElem = <ListGroupItem key={i}>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='row-label'>{t(group.group_name)}</label>
                        </div>
                        <div className='col-md-10'>
                          {group.fields && this.fill(group.fields, group.columns, group.fields_affect_premium)}
                          {group.addon && this.showAddon(group)}
                          <div className='static-text'>{t(group.static_text)}</div>
                        </div>
                      </div>
                    </ListGroupItem>;
                    return this.isGroupHidden(group) || ( !this.showIfEveryIsTrue(group) || group.show_only_when === 'edit' && !this.state.editMode) || (group.show_only_when === 'view' && this.state.editMode) ?
                      null : groupElem;
                  }
                )
              }
              {
                this.state.editMode && !this.isPolicyStatus('cancelled') ? <ListGroupItem>
                  <div className="row">
                    <div className="col-md-2"></div>
                    <div className="col-md-10">
                      <Button
                        disabled={(this.state.quoteResponseData && this.getPremiumDifference() !== 0) || this.state.savingChanges}
                        onClick={this.alertModal.bind(this)}>
                        {this.state.savingChanges ? <Icon spin name="spinner"/> : <Icon name="save"/>} {t('Save Changes')}
                      </Button>
                    </div>
                  </div>
                </ListGroupItem> : null
              }
            </ListGroup>
          </Panel>
          <LoadingComponent show={this.state.loading} text={this.state.loadingText}/>

          <ModalComponent
            title={this.state.modalTitle}
            body={this.state.modalBody}
            onClose={this.handleModalClose.bind(this)}
            show={this.state.showModal}
            resetDataOnClose={this.state.resetDataOnClose}
            onSubmit={this.state.onSubmitModal}
            buttonName={this.state.onSubmitModalButtonName}
          />

          <ModalComponent
            title={this.state.alertModalTitle}
            body={this.state.alertModalBody}
            onClose={this.resetData.bind(this)}
            closeButton={t('Discard Changes')}
            show={this.state.showAlertModal}
            onSubmit={this.state.modalAction}
            buttonName={this.state.modalOptionalButton}
          />


          {this.state.showCancelPolicy ?
            <CancelPolicyConfirmationComponent data={this.state.paymentHistoryData}
              premiumDifference={this.getOriginalPremium()}
              show={this.state.showCancelPolicy}
              onClose={this.handleRefundAndCancelPolicyClose.bind(this)}
              source={this.getSource()}
              applicationId={this.getApplicationId()}
              policyNumber={this.state.data.getIn(['applicant', '0', 'policy_number'])}
              refund={this.getOriginalPremium()}
              setCancellationFee={this.getSetCancellationFee()}
              policyCancellationFee={this.state.policy_application_fee}
              applicationData={this.state.data}
              showLoading={this.showLoading.bind(this)}
              hideLoading={this.hideLoading.bind(this)}
              showModal={this.showModal.bind(this)}
              isRefund={this.isPolicyStatus('cancelled')}
          /> : null}
        </div> : <LoadingComponent show/>;
  }
}
Manage.displayName = 'Manage';
export default Manage;



// WEBPACK FOOTER //
// ./src/components/Manage.js